import {request} from "./request";

export function getFriendData(page,token) {
  return request({
    url: '/friend/friendList',
    data: {
      'page': page,
      'pageSize': '10',
    }
  },token)
}

export function stealFriendWorkpiece(friendId,token) {
  return request({
    url: '/friend/steal',
    data: {
      'friendId': friendId
    }
  },token)
}

export function sendFriendWorkpiece(friendId,token) {
  return request({
    url: '/friend/sendPart',
    data: {
      'friendId': friendId,
      'partAmount': 1
    }
  },token)
}

export function getFriendRequest(token) {
  return request({
    url: '/friend/requestList',
    data: {
      'page': 1,
      'pageSize': 5
    }
  },token)
}
export function makeFriend(id,token) {
  return request({
    url: '/friend/makeFriends',
    data: {
      'friendId': id
    }
  },token)
}

export function handleFriendRequest(id,result,token) {
  return request({
    url: '/friend/requestHandle',
    data: {
      'id': id,
      'requestResult':result
    }
  },token)
}
